// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./channels/consumer"
import "./controllers"

Turbo.setProgressBarDelay(200)

// Custom Turbo Stream Actions
Turbo.StreamActions.closeTradeModal = function () {
  window.dispatchEvent(new CustomEvent("mulatrade:trade-completed"))
}
